export default "__VITE_ASSET__J56$5yRt__"